module.exports = __webpack_public_path__ + "static/media/md-photos.5e68ad9b.svg";